import vala from "@public/img/um-okkur/employees/vala.webp";
import adalbjorg from "@public/img/um-okkur/employees/adalbjorg.webp";
import soley from "@public/img/um-okkur/employees/soley.webp";
import klara from "@public/img/um-okkur/employees/klara.webp";
import asta from "@public/img/um-okkur/employees/asta.webp";
import sveinborg from "@public/img/um-okkur/employees/sveinborg.webp";
import halldor from "@public/img/um-okkur/employees/halldor.webp";

const BOARD_MEMBERS2 = [
    {
        image: vala,
        name: "Vala Smáradóttir",
        position: "Vöru og þróunarstjóri",
    },
    {
        image: adalbjorg,
        name: "Aðalbjörg Egilsdóttir",
        position: "Fræðslustjóri",
    },
    {
        image: soley,
        name: "Sóley Kristinsdóttir",
        position: "Sjálfbærniráðgjafi",
    },
    {
        image: klara,
        name: "Klara Rut Olafsdóttir",
        position: "Umhverfismælaborðs",
    },
    {
        image: asta,
        name: "Ásta Ágústsdóttir",
        position: "Umhverfismælaborð og sjálfbærniráðgjafi",
    },
    {
        image: sveinborg,
        name: "Sveinborg K. Daníelsdóttir ",
        position: "Sjálfbærniráðgjafi og umhverfismælaborð",
    },
    {
        image: halldor,
        name: "Halldór J. Árnason",
        position: "Skrifstofa og bókhald",
    },
];

export default BOARD_MEMBERS2;
